const { CREATED } = require("./StatusConstants")
export const CREATED_LOG = "Created";
export const ACCEPTED_LOG = "Accepted";
export const POSTPONED_LOG = "Postponed";
export const ON_THE_WAY_LOG = "OnTheWay";
export const IN_PROGRESS_LOG = "InProgress";
export const COMPLETED_LOG = "Completed";
export const CANCELLED_LOG = "Cancelled";
